const loadItems = (button, isAutoLoad = false) => {
  const loaderContainer = document.getElementById("bucket-loader");
  const bucket = document.querySelector(".bucket-image");

  // Show loader and reset bucket position
  if (loaderContainer && bucket) {
    loaderContainer.style.display = "block";
    bucket.style.transition = "none";
    bucket.style.transform = "translateY(0px)";
  }

  const loadStart = performance.now();

  const totalPages = parseInt($("[data-total-pages]").val());
  let currentPage = parseInt($("[data-current-page]").val());
  const currentPageScroll = currentPage + 1;

  currentPage += 1;

  const nextUrl = $("[data-next-url]").val().replace(/page=[0-9]+/, "page=" + currentPage);
  const nextUrlScroll = $("[data-next-url]").val().replace(/page=[0-9]+/, "page=" + currentPageScroll);

  $("[data-current-page]").val(currentPage);

  if (!isAutoLoad && button) {
    button.setAttribute("disabled", "");
    button.classList.add("loading");
  }

  fetch(nextUrl)
    .then((response) => response.text())
    .then((responseHTML) => {
      const htmlDoc = new DOMParser().parseFromString(responseHTML, "text/html");
      const newItems = htmlDoc.querySelector(".load-more-grid").innerHTML;
      document.querySelector(".load-more-grid").insertAdjacentHTML("beforeend", newItems);

      if (typeof colorSwatches === "function") colorSwatches();

      // Measure load duration
      const loadEnd = performance.now();
      const loadTime = loadEnd - loadStart;
      const maxDrop = 60; // pixels lowered

      // Animate bucket lowering
      if (bucket) {
        bucket.style.transition = `transform ${loadTime / 1000}s linear`;
        bucket.style.transform = `translateY(${maxDrop}px)`;
      }

      // Prefetch next page
      if (currentPage + 1 <= totalPages) {
        const prefetchUrl = nextUrl.replace(/page=[0-9]+/, "page=" + (currentPage + 1));
        fetch(prefetchUrl);
      }

      // Update pagination data
      const scollData = document.querySelector(".infinite-scroll__data");
      if (scollData && currentPage !== totalPages) {
        scollData.querySelector("input[data-next-url]").dataset.nextUrl = nextUrlScroll;
        scollData.querySelector("input[data-next-url]").value = nextUrlScroll;
        scollData.querySelector("input[data-current-page]").dataset.currentPage = currentPage;
        scollData.querySelector("input[data-current-page]").value = currentPage;
        checkVisibility();
      }
    })
    .catch(console.error)
    .finally(() => {
      if (!isAutoLoad && button) {
        button.removeAttribute("disabled");
        button.classList.remove("loading");
      }

      // Hide loader and reset bucket after small delay
      setTimeout(() => {
        if (loaderContainer) loaderContainer.style.display = "none";
        if (bucket) {
          bucket.style.transition = "none";
          bucket.style.transform = "translateY(0px)";
        }
      }, 200);
    });
};

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
            sectionObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "600px" } // Trigger early
    );
    sectionObserver.observe(spinner);
  });
};

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => loadItems(button);
  });
  checkVisibility();
}

document.addEventListener("DOMContentLoaded", () => {
  loadMore();
});
